/* BRAZ theme behaviour (store rebuild, design v2). Vanilla, no dependencies, event-delegated.
   Panels (menu, search, cart), AJAX cart through the Section Rendering API, product page
   (gallery, colour, single/set, add to cart, sticky bar), cards, video, delivery dates.
   Prices and variants always come from data-* attributes written by Liquid, never typed here. */
(function () {
  'use strict';
  var d = document;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var money = function (cents) { return fmt.format(cents / 100); };
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ---------- panels ---------- */
  var lastFocus = null;
  function overlay() { return $('.bz .bz-overlay'); }
  function openPanel(id) {
    var p = d.getElementById(id); if (!p) return;
    closePanels(false);
    lastFocus = d.activeElement;
    p.classList.add('is-open');
    var o = overlay(); if (o) o.classList.add('is-open');
    d.body.classList.add('locked');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var f = id === 'search' ? $('input[type="search"]', p) : p; (f || p).focus(); }, 50);
  }
  function closePanels(restore) {
    $$('.bz .panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    var o = overlay(); if (o) o.classList.remove('is-open');
    d.body.classList.remove('locked');
    $$('[aria-controls][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var lb = $('.bz .lightbox.is-open'); if (lb) lb.classList.remove('is-open');
    if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- cart (AJAX; the drawer is the braz-cart-drawer section) ---------- */
  var SECTION = 'braz-cart-drawer';
  function paintCart(html) {
    var cur = $('#cart'); if (!cur || !html) return;
    var tmp = d.createElement('div'); tmp.innerHTML = html;
    var next = $('#cart', tmp); if (!next) return;
    cur.innerHTML = next.innerHTML;
    var n = parseInt(next.getAttribute('data-count') || '0', 10);
    $$('.bz .cart-count').forEach(function (c) { c.textContent = n; c.setAttribute('data-n', n); });
  }
  function cartCall(path, body) {
    body.sections = SECTION;
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { paintCart(j.sections && j.sections[SECTION]); return j; });
  }
  function refreshCart() {
    return fetch(root + '?sections=' + SECTION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (j) { paintCart(j[SECTION]); });
  }
  var Braz = window.Braz = {
    money: money,
    addItems: function (items) { return cartCall('cart/add.js', { items: items }); },
    change: function (line, qty) { return cartCall('cart/change.js', { line: line, quantity: qty }); },
    openCart: function () { openPanel('cart'); },
    refreshCart: refreshCart
  };

  /* ---------- button states ---------- */
  function setLabel(btn, text) { var l = $('[data-label]', btn) || btn; l.textContent = text; }
  function addWithButton(btn, items, errBox) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var original = btn.getAttribute('data-label-default') || ($('[data-label]', btn) || btn).textContent;
    btn.setAttribute('data-label-default', original);
    btn.classList.add('is-loading'); setLabel(btn, 'Adding…');
    if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
    Braz.addItems(items).then(function () {
      btn.classList.remove('is-loading'); btn.classList.add('is-added'); setLabel(btn, 'Added');
      openPanel('cart');
      setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, original); }, 1400);
    }).catch(function (e) {
      btn.classList.remove('is-loading'); setLabel(btn, original);
      if (errBox) { errBox.hidden = false; errBox.textContent = (e && (e.description || e.message)) || 'We could not add that. Please try again.'; }
    });
  }

  /* ---------- delivery window: 1-3 processing + 7-14 delivery business days ---------- */
  function addBusiness(date, n) { var x = new Date(date); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w && w < 6) n--; } return x; }
  function deliveryText() {
    var f = function (x) { return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var now = new Date();
    return f(addBusiness(now, 8)) + ' – ' + f(addBusiness(now, 17));
  }

  /* ---------- gallery ---------- */
  function initGallery(g) {
    var main = $('.g-main', g), slides = $$('.g-slide', main), thumbs = $$('.g-thumb', g), count = $('.g-count', g);
    if (!slides.length) return;
    function setCurrent(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      var t = thumbs[i]; if (t && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    function goTo(i, smooth) {
      var s = slides[i]; if (!s) return;
      main.scrollTo({ left: s.offsetLeft - main.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setCurrent(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var raf;
    main.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var x = main.scrollLeft, best = 0, dist = Infinity;
        slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - main.offsetLeft - x); if (dd < dist) { dist = dd; best = i; } });
        setCurrent(best);
      });
    });
    g.__goColour = function (key, smooth) {
      var i = slides.findIndex(function (s) { return s.getAttribute('data-gcolour') === key; });
      if (i > -1) goTo(i, smooth);
    };
    setCurrent(0);
  }

  /* ---------- product page ---------- */
  function initProduct(sec) {
    var form = $('form#bz-product-form', sec), gallery = $('.gallery', sec);
    var pills = $$('[data-colour]', sec), idInput = $('input[name="id"]', form);
    var offers = $$('[data-offer]', sec), extra = $('.set-extra', sec);
    var priceEls = $$('[data-atc-price]'), errBox = $('[data-bz-error]', sec);
    var atcs = $$('[data-atc]');
    var state = { variant: null, offer: 'single', partner: null };
    var cur = pills.filter(function (p) { return p.getAttribute('aria-checked') === 'true'; })[0] || pills[0];
    var partnerPills = $$('[data-wvariant]', sec);
    state.partner = partnerPills.filter(function (p) { return p.getAttribute('aria-checked') === 'true'; })[0] || partnerPills[0] || null;
    var setCut = parseInt(sec.getAttribute('data-set-cut') || '0', 10);

    function totalCents() {
      var base = parseInt(cur.getAttribute('data-price'), 10) || 0;
      if (state.offer === 'set' && state.partner) base += parseInt(state.partner.getAttribute('data-price'), 10) - setCut;
      return base;
    }
    function paint() {
      var available = cur.getAttribute('data-available') !== 'false' && (state.offer !== 'set' || !state.partner || state.partner.getAttribute('data-available') !== 'false');
      atcs.forEach(function (b) {
        if (b.classList.contains('is-loading') || b.classList.contains('is-added')) return;
        b.disabled = !available;
        var l = $('[data-label]', b); if (l) l.textContent = available ? 'Add to cart' : 'Sold out';
        b.setAttribute('data-label-default', available ? 'Add to cart' : 'Sold out');
      });
      priceEls.forEach(function (e) { e.textContent = available ? money(totalCents()) : ''; });
      $$('[data-title-price]', sec).forEach(function (e) { e.textContent = money(parseInt(cur.getAttribute('data-price'), 10)); });
      $$('[data-colour-name]').forEach(function (e) { e.textContent = cur.getAttribute('data-name'); });
      $$('[data-sticky-img]').forEach(function (e) { var u = cur.getAttribute('data-img'); if (u) e.src = u; });
      $$('[data-offer-img]', sec).forEach(function (e) { var u = cur.getAttribute('data-img'); if (u) e.src = u; });
      idInput.value = cur.getAttribute('data-variant');
    }
    function selectColour(p, jump) {
      cur = p;
      pills.forEach(function (x) { x.setAttribute('aria-checked', String(x === p)); });
      paint();
      if (jump !== false && gallery && gallery.__goColour) gallery.__goColour(p.getAttribute('data-colour'));
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', p.getAttribute('data-variant')); history.replaceState(null, '', u.toString()); }
    }
    pills.forEach(function (p) { p.addEventListener('click', function () { selectColour(p); }); });
    offers.forEach(function (o) {
      o.addEventListener('click', function () {
        state.offer = o.getAttribute('data-offer');
        offers.forEach(function (x) { x.setAttribute('aria-checked', String(x === o)); });
        if (extra) extra.hidden = state.offer !== 'set';
        paint();
      });
    });
    partnerPills.forEach(function (p) {
      p.addEventListener('click', function () {
        state.partner = p;
        partnerPills.forEach(function (x) { x.setAttribute('aria-checked', String(x === p)); });
        var nm = $('[data-wname]', sec); if (nm) nm.textContent = p.getAttribute('data-name');
        paint();
      });
    });
    function items() {
      var list = [{ id: parseInt(cur.getAttribute('data-variant'), 10), quantity: 1 }];
      if (state.offer === 'set' && state.partner) list.push({ id: parseInt(state.partner.getAttribute('data-wvariant'), 10), quantity: 1 });
      return list;
    }
    atcs.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addWithButton(b, items(), errBox); }); });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (atcs[0]) addWithButton(atcs[0], items(), errBox); });

    /* sticky bar: shows once the main button has scrolled away, hides near the footer */
    var sticky = $('.sticky-atc'), main = $('#atc'), foot = $('.bz .footer');
    if (sticky && main) {
      d.body.classList.add('has-sticky');
      var atcVisible = true, footVisible = false;
      var upd = function () { sticky.classList.toggle('is-shown', !atcVisible && !footVisible && main.getBoundingClientRect().top < 0); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(main);
        if (foot) new IntersectionObserver(function (en) { footVisible = en[0].isIntersecting; upd(); }).observe(foot);
      }
      addEventListener('scroll', upd, { passive: true });
    }
    $$('[data-delivery]').forEach(function (e) { e.textContent = deliveryText(); });
    var wanted = new URL(location.href).searchParams.get('variant');
    if (wanted) { var m = pills.filter(function (p) { return p.getAttribute('data-variant') === wanted; })[0]; if (m) { selectColour(m, false); if (gallery && gallery.__goColour) setTimeout(function () { gallery.__goColour(m.getAttribute('data-colour'), false); }, 0); } }
    paint();
  }

  /* ---------- cards: swatch changes the photo and the link ---------- */
  function initCard(card) {
    var sws = $$('[data-sw]', card), img1 = $('.img-1', card), img2 = $('.img-2', card), name = $('[data-cname]', card);
    sws.forEach(function (sw) {
      sw.addEventListener('click', function () {
        sws.forEach(function (s) { s.setAttribute('aria-checked', String(s === sw)); });
        if (img1 && sw.getAttribute('data-img')) img1.src = sw.getAttribute('data-img');
        if (img2) img2.src = sw.getAttribute('data-img2') || sw.getAttribute('data-img');
        if (name) name.textContent = sw.getAttribute('data-name') + ' · ' + sws.length + ' colours';
        var qa = $('[data-quick]', card); if (qa && sw.getAttribute('data-variant')) qa.setAttribute('data-add-variant', sw.getAttribute('data-variant'));
        $$('a[data-card-link]', card).forEach(function (a) { var base = a.getAttribute('data-card-link'); a.href = sw.getAttribute('data-variant') ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + sw.getAttribute('data-variant') : base; });
      });
    });
  }

  /* ---------- global clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-open]'); if (o) { e.preventDefault(); openPanel(o.getAttribute('data-open')); return; }
    if (t.closest('[data-close]')) { closePanels(); return; }
    var q = t.closest('[data-qty]'); if (q) { e.preventDefault(); if (!q.disabled) Braz.change(parseInt(q.getAttribute('data-line'), 10), parseInt(q.getAttribute('data-qty'), 10)); return; }
    var r = t.closest('[data-remove]'); if (r) { e.preventDefault(); Braz.change(parseInt(r.getAttribute('data-remove'), 10), 0); return; }
    var a = t.closest('[data-add-variant]'); if (a) { e.preventDefault(); addWithButton(a, [{ id: parseInt(a.getAttribute('data-add-variant'), 10), quantity: 1 }]); return; }
    var z = t.closest('.zoom'); if (z) {
      var lb = $('.bz .lightbox'); if (!lb) return;
      lb.querySelector('img').src = z.getAttribute('data-full'); lb.querySelector('img').alt = z.getAttribute('aria-label') || '';
      lb.classList.add('is-open'); d.body.classList.add('locked'); var cb = lb.querySelector('button'); if (cb) cb.focus(); return;
    }
    var lbc = t.closest('[data-close-lightbox]'); if (lbc) { var l2 = $('.bz .lightbox'); l2.classList.remove('is-open'); d.body.classList.remove('locked'); return; }
    var pl = t.closest('[data-play]'); if (pl) {
      var wrap = pl.parentElement, src = pl.getAttribute('data-play');
      var v = d.createElement('video'); v.src = src; v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.setAttribute('aria-label', 'The tote packed and lifted, silent');
      wrap.innerHTML = ''; wrap.appendChild(v); v.play && v.play().catch(function () {}); return;
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  d.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]'); if (!sel) return;
    var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  /* ---------- newsletter: client check, then the real Shopify form posts ---------- */
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('form.signup'); if (!f) return;
    var inp = $('input[type="email"]', f), msg = $('[data-signup-msg]', f.parentElement);
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value);
    inp.setAttribute('aria-invalid', String(!ok));
    if (!ok) { e.preventDefault(); if (msg) { msg.className = 'field-msg err'; msg.textContent = 'Please enter a full email address, like name@example.com.'; } }
  });

  function boot() {
    $$('.bz .gallery').forEach(initGallery);
    var pdp = $('[data-bz-product]'); if (pdp) initProduct(pdp);
    $$('.bz [data-card]').forEach(initCard);
    $$('[data-delivery]').forEach(function (e) { e.textContent = deliveryText(); });
    var p = new URL(location.href).searchParams;
    if (p.get('cart') === 'open') openPanel('cart');
    if (p.get('menu') === 'open') openPanel('menu');
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
